import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114')
];

export const server_loads = [];

export const dictionary = {
		"/": [8],
		"/admin": [9,[2]],
		"/admin/clara/analytics": [10,[2,3]],
		"/admin/clara/reflections": [11,[2,3]],
		"/admin/clara/reflections/[sessionId]": [12,[2,3]],
		"/admin/clara/reports": [13,[2,3]],
		"/admin/clara/rules": [14,[2,3]],
		"/admin/clara/rules/professions": [15,[2,3]],
		"/admin/clara/rules/professions/[professionId]": [16,[2,3]],
		"/admin/clara/rules/users": [17,[2,3]],
		"/admin/clara/rules/users/[userId]": [18,[2,3]],
		"/admin/clara/settings": [19,[2,3]],
		"/admin/connection-overview": [20,[2]],
		"/admin/consultations": [21,[2]],
		"/admin/manual-credit": [22,[2]],
		"/admin/matching-answers": [23,[2]],
		"/admin/matching-interests": [24,[2]],
		"/admin/organisations": [25,[2]],
		"/admin/signal/analytics": [26,[2]],
		"/admin/signal/funnels/[funnelId]": [27,[2]],
		"/admin/signal/funnels/[funnelId]/claimed-leads": [28,[2]],
		"/admin/signal/funnels/[funnelId]/claimed-reflections": [29,[2]],
		"/admin/signal/funnels/[funnelId]/claimed-reflections/[matchId]": [30,[2]],
		"/admin/signal/funnels/[funnelId]/pending-leads": [31,[2]],
		"/admin/signal/funnels/[funnelId]/pending-reflections": [32,[2]],
		"/admin/signal/funnels/[funnelId]/pending-reflections/[pendingId]": [33,[2]],
		"/admin/signal/settings": [34,[2]],
		"/admin/users": [35,[2]],
		"/admin/verify": [36,[2]],
		"/auth/callback": [37],
		"/chat": [38,[4]],
		"/chat/[roomId]": [39,[4]],
		"/clara": [40,[5]],
		"/clara/capture/[captureId]": [41,[5]],
		"/clara/claim/[token]": [42,[5]],
		"/clara/reflection/[sessionId]": [43,[5]],
		"/clara/reflection/[sessionId]/complete": [44,[5]],
		"/clara/signup": [45,[5]],
		"/clara/verify": [46,[5]],
		"/dashboard/clara": [47],
		"/dashboard/clara/availability": [48],
		"/dashboard/clara/campaigns/[campaignId]": [49],
		"/dashboard/clara/campaigns/[campaignId]/reflect": [50],
		"/dashboard/clara/consultations/[consultationId]": [51],
		"/dashboard/clara/copay": [52],
		"/dashboard/clara/innovators": [53],
		"/dashboard/clara/insights": [54],
		"/dashboard/clara/my-sessions": [55],
		"/dashboard/clara/reflect": [56],
		"/dashboard/clara/sessions": [57],
		"/dashboard/clara/sessions/[sessionId]": [58],
		"/dashboard/clara/sessions/[sessionId]/cpd": [59],
		"/dashboard/clara/sessions/[sessionId]/reflect": [60],
		"/dashboard/message-room": [61],
		"/dashboard/message-room/[roomId]": [62],
		"/forgot-password": [63],
		"/login": [64],
		"/meetings": [65],
		"/meetings/[consultationId]": [66],
		"/onboarding/account-type": [67],
		"/onboarding/general": [68,[6]],
		"/onboarding/general/banking": [69,[6]],
		"/onboarding/general/stripe": [70,[6]],
		"/onboarding/healthcare": [71],
		"/onboarding/healthcare/profession": [72],
		"/onboarding/industry": [73],
		"/onboarding/industry/join-pending": [74],
		"/onboarding/industry/organisation": [75],
		"/organisations/[organisationId]/campaign-followup": [76,[7]],
		"/organisations/[organisationId]/campaign-reports": [77,[7]],
		"/organisations/[organisationId]/campaign-responses": [78,[7]],
		"/organisations/[organisationId]/campaigns": [79,[7]],
		"/organisations/[organisationId]/consultations": [80,[7]],
		"/organisations/[organisationId]/consultations/[consultationId]": [81,[7]],
		"/organisations/[organisationId]/credit": [82,[7]],
		"/organisations/[organisationId]/details": [83,[7]],
		"/organisations/[organisationId]/export-agreement-docs": [84,[7]],
		"/organisations/[organisationId]/invoices": [85,[7]],
		"/organisations/[organisationId]/organisation-content": [86,[7]],
		"/organisations/[organisationId]/payments": [87,[7]],
		"/organisations/[organisationId]/signal": [88,[7]],
		"/organisations/[organisationId]/signal/campaigns": [89,[7]],
		"/organisations/[organisationId]/signal/campaigns/[campaignId]/performance": [90,[7]],
		"/organisations/[organisationId]/signal/consultations": [91,[7]],
		"/organisations/[organisationId]/signal/engagement": [92,[7]],
		"/organisations/[organisationId]/signal/funnels": [93,[7]],
		"/organisations/[organisationId]/signal/funnels/new": [96,[7]],
		"/organisations/[organisationId]/signal/funnels/[funnelId]": [94,[7]],
		"/organisations/[organisationId]/signal/funnels/[funnelId]/engagement": [95,[7]],
		"/organisations/[organisationId]/signal/leads": [97,[7]],
		"/organisations/[organisationId]/signal/matches": [98,[7]],
		"/organisations/[organisationId]/signal/matches/[matchId]": [99,[7]],
		"/organisations/[organisationId]/signal/tracks/new": [106,[7]],
		"/organisations/[organisationId]/signal/tracks/[funnelId]": [100,[7]],
		"/organisations/[organisationId]/signal/tracks/[funnelId]/campaigns": [101,[7]],
		"/organisations/[organisationId]/signal/tracks/[funnelId]/leads": [102,[7]],
		"/organisations/[organisationId]/signal/tracks/[funnelId]/meetings": [103,[7]],
		"/organisations/[organisationId]/signal/tracks/[funnelId]/reflections": [104,[7]],
		"/organisations/[organisationId]/signal/tracks/[funnelId]/reflections/[matchId]": [105,[7]],
		"/organisations/[organisationId]/transfer-of-value": [107,[7]],
		"/organisations/[organisationId]/users": [108,[7]],
		"/organisations/[organisationId]/users/[userId]": [109,[7]],
		"/profile": [110],
		"/reset-password": [111],
		"/signup": [112],
		"/signup/verify": [113],
		"/sso/[nonce]": [114]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';